import React from 'react'
import Link from 'gatsby-link'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import 'semantic-ui-css/semantic.min.css'

import Navbar from '../components/navbar'
import Footer from '../components/footer';
import favicon from '../images/favicon.ico';
import logo from '../images/logo.png';
// import './index.css'
import '../styles/app.scss';
import '../helpers/pollyfill.js'

const Layout = ({ children, data }) => {


  return (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: 'PME-NA 2018 national conference held in Greenville, SC.' },
        { name: 'keywords', content: 'PMENA, math education, math' },
        { name: 'twitter:card', content: '@pmena2018sc' },
        { name: 'twitter:site', content: '' },
        { name: 'twitter:url', content: 'https://pmena2018.org' },
        { name: 'twitter:title', content: 'PMENA, math education, math' },
        { name: 'twitter:title', content: 'PME-NA 40 | 2018 Conference' },
        { name: 'twitter:description', content: 'PME-NA 2018 national conference held in Greenville, SC.' },
        { name: 'twitter:image', content: logo },
        { property: 'og:title', content: 'PME-NA 40 | 2018 Conference' },
        { property: 'og:description', content: 'PME-NA 2018 national conference held in Greenville, SC.' },
        { property: 'og:url', content: 'https://pmena2018.org' },
        { property: 'og:image', content: logo },
      ]}
    >
        <link rel="shortcut icon" href={favicon} />
    </Helmet>

    <Navbar />
    <div>
      {children()}
    </div>
    <Footer/>
  </div>
)}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js